import {
    api_url,
    legendLabelsBoxHeightLine,
    configChartsColorPalettes,
    yRight,
    partMobilityIndicators,
    popupInformation,
    defaultBarPercentage,
    defaultCategoryPercentage,
    defaultDatalabelsAlign,
    defaultTicksCustomValue,
} from "../../../utils";

import settings from "../../../../settings.js";

const NbDeplacementsQuotidiens = {
    checked: false,
    titleSideBar:
        "Mobility Indicators Content.indicators.NbDeplacementsQuotidiens",
    titleIndicator:
        "Mobility Indicators Content.indicators.NbDeplacementsQuotidiens",
    popupInformation: {
        status: "false",
        text: popupInformation[partMobilityIndicators][
            "nbDeplacementsQuotidiens"
        ],
    },
    keyFigure: {
        typeUpdate: "year", // year or geographical_area
        label: "Mobility Indicators Content.charts.NbDeplacementsQuotidiens.keyFigure.trips",
        url:
            api_url +
            "charts/data/?part=mobility-indicators&type_label=cusco_years&indicator=nb_deplacements_quotidiens&trend=projection&chart=nb_deplacements_quotidiens&chart_data=False&indicator_key_figure=True&schema_city=",
        separator: "thousand",
        position: "",
    },
    charts: [
        {
            typeChart: "bar",
            typeLabels: "geographical_areas", // years or geographical_areas
            multiYearGeographicalArea: true,
            singleYearGeographicalAreaType: "year", // year or geographical_area : MUST BE CONSISTENT WITH THE TYPE_LABEL ARGUMENT OF THE DATASET URL
            titleChart: "",
            titleDisplay: "true",
            legendDisplay: "false",
            legendCustom: "false",
            legendLabelsBoxHeight: legendLabelsBoxHeightLine,
            maintainAspectRatio: false,
            indexAxis: "y", // x or y
            heightChart: "200",
            widthChart: "600",
            scales: {
                x: {
                    type: "linear",
                    display: true,
                    stacked: true,
                    titleDisplay: true,
                    titleText:
                        "Mobility Indicators Content.charts.NbDeplacementsQuotidiens.axis.titleX",
                    gridDisplay: true,
                    beginAtZero: true,
                    min: 0,
                    max: 1000000,
                    ticks: {
                        display: true,
                        value: defaultTicksCustomValue,
                        stepSize: 200000,
                    },
                },
                y: {
                    type: "category",
                    display: true,
                    stacked: true,
                    titleDisplay: true,
                    titleText: "",
                    gridDisplay: false,
                    beginAtZero: false,
                    ticks: {
                        display: false,
                        value: defaultTicksCustomValue,
                    },
                },
                yRight: yRight,
            },
            annotationsProperties: {
                annotation1: undefined,
                annotation2: undefined,
            },
            keyFigure: {
                typeUpdate: "geographical_area", // year or geographical_area
                label: "",
                url: "",
                separator: "",
                position: "",
            },

            datasets: settings.config.citiesDetails.map((city, index) => {
                let label =
                    "Mobility Indicators Content.charts.NbDeplacementsQuotidiens.legend.Provincia de " +
                    city.label;
                let url =
                    api_url +
                    "charts/data/?part=mobility-indicators&type_label=cusco_geographical_areas&indicator=nb_deplacements_quotidiens&trend=projection&chart=nb_deplacements_quotidiens" +
                    city.dbId +
                    "&schema_city=";
                return {
                    type: "bar",
                    label: label,
                    data: [],
                    url: url,
                    backgroundColor:
                        configChartsColorPalettes["0"].backgroundColor[index],
                    borderColor:
                        configChartsColorPalettes["0"].borderColor[index],
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit:
                        "Mobility Indicators Content.charts.NbDeplacementsQuotidiens.tooltipUnit. déplacements / jour",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: defaultCategoryPercentage,
                    datalabelsProperties: {
                        display: true,
                        anchor: "start",
                        align: defaultDatalabelsAlign,
                        color: "#FFFFFF",
                        font: {
                            weight: "bold",
                        },
                        value: {
                            prefix: "",
                            suffix: "",
                            separator: "thousand",
                            excludeValues: ["53102", "53851", "17498"],
                        },
                    },
                };
            }),
        },
    ],
};

export default NbDeplacementsQuotidiens;
